export default __webpack_public_path__ + "static/media/cerec_second.b653fccf.jpg";